export default __webpack_public_path__ + "static/media/CodingLab.924e4fb7.webp";